<template>
  <div class="content">
    <CustomTable ref="CustomTable" v-loading="loading" @init="init" @handelBtnClick="handelBtnClick"
      :filterData="filterData" :headerData="headerData" :btnsData="btnsData" :data="data" :pagination="pagination">
    </CustomTable>
  </div>
</template>
  
<script>
import CustomTable from "@/components/custom/CustomTable";
export default {
  components: { CustomTable },
  data() {
    return {
      filterData: [
        { label: "姓名", prop: "name", type: "input" },
        { label: "会员单位名称", prop: "UnitName", type: "input" },
        {
          label: "政治风貌", prop: "political", type: "select",
          opt: [
            { label: "党员", value: "党员" },
            { label: "预备党员", value: "预备党员" },
            { label: "群众", value: "群众" },
          ],
        },
        {
          label: "技术职称", prop: "title", type: "inputSelect", opt: [
            { label: "教授或教授级高级工程师", value: "教授或教授级高级工程师" }, 
            { label: "正高级职称", value: "正高级职称" }, 
            { label: "副高级职称", value: "副高级职称" }, 
            { label: "中级职称", value: "中级职称" }, 
            { label: "初级职称", value: "初级职称" }
          ],
        },
        { label: "起始年龄", prop: "ageStart", type: "input" },
        { label: "终止年龄", prop: "ageEnd", type: "input" },

      ],
      headerData: [
        { label: "会员号", prop: "memberNum" },
        { label: "用户名", prop: "userName" },
        { label: "姓名", prop: "name" },
        { label: "身份证号码", prop: "idCard" },
        // { label: "邮箱", prop: "email" },
        { label: "用户类型", prop: "unitType" },
        { label: "所属单位", prop: "unitName" },
        { label: "认缴金额 (元)", prop: "promisePayAmount" },
        { label: "认缴", prop: "promisePay", },
        { label: "预备", prop: "perMember", },
        { label: "缴费", prop: "pay", },
        { label: "专家", prop: "expert", },
        {
          label: "审核状态",
          prop: "auditingStatus",
        },
        { label: "状态", prop: "status", },
      ],
      btnsData: [
        { label: "导出", value: "export" },
      ],
      data: [],
      addFormData: [
        {
          label: "用户名",
          prop: "userName",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "个人照片",
          prop: "img",
          type: "upload",
          value: [],
          required: false,
          span: 24,
        },
        {
          label: "会员单位名称",
          prop: "unitName",
          type: "input",
          value: "",
          required: false,
          span: 24,
        },
        {
          label: "姓名",
          prop: "name",
          type: "input",
          value: "",
          required: true,
          span: 12,
        },
        {
          label: "身份证号码",
          prop: "idCard",
          type: "input",
          value: "",
          required: true,
          span: 12,
        },
        {
          label: "性别",
          prop: "sex",
          type: "select",
          value: "",
          required: false,
          opt: [
            { label: "男", value: "M" },
            { label: "女", value: "F" },
          ],
          span: 12,
        },
        {
          label: "政治风貌",
          prop: "political",
          type: "select",
          value: "",
          required: false,
          opt: [
            { label: "党员", value: "党员" },
            { label: "预备党员", value: "预备党员" },
            { label: "群众", value: "群众" },
          ],
          span: 12,
        },
        {
          label: "出生年月",
          prop: "dob",
          type: "date",
          value: "",
          required: false,
          span: 12,
        },
        {
          label: "技术职称",
          prop: "title",
          type: "inputSelect",
          value: "",
          required: false,
          opt: [
            { label: "教授或教授级高级工程师", value: "教授或教授级高级工程师" }, 
            { label: "正高级职称", value: "正高级职称" }, 
            { label: "副高级职称", value: "副高级职称" }, 
            { label: "中级职称", value: "中级职称" }, 
            { label: "初级职称", value: "初级职称" }
          ],
          span: 12,
        },
        {
          label: "学历",
          prop: "edu",
          type: "select",
          value: "",
          required: false,
          opt: [
            { label: "研究生", value: "研究生" },
            { label: "本科", value: "本科" },
            { label: "中专/高中", value: "中专/高中" },
            { label: "初中", value: "初中" },
            { label: "小学", value: "小学" },
          ],
          span: 12,
        },
        {
          label: "联系电话",
          prop: "mobile",
          type: "input",
          value: "",
          required: true,
          span: 12,
        },
        {
          label: "办公室电话",
          prop: "officeNum",
          type: "input",
          value: "",
          required: false,
          span: 24,
        },
        // {
        //   label: "邮箱",
        //   prop: "email",
        //   type: "input",
        //   value: "",
        //   required: true,
        //   span: 12,
        // },
        {
          label: "简历",
          prop: "resume",
          type: "editor",
          value: "",
          required: false,
          span: 24,
        },
      ],
      loading: false,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      selectData: {},
      dialogVisible: false,
      createdType: "",
      queryParams: {}
    };
  },
  methods: {
    handelBtnClick(type) {
      this.createdType = type;
      switch (type) {
        case "export":
          this.$https
            .postForm(
              this.$api.Members.reportExport,
              this.queryParams,
            )
            .then((res) => {
              let a = document.createElement("a");
              //ArrayBuffer 转为 Blob
              let blob = new Blob([res], { type: "application/vnd.ms-excel" });
              let objectUrl = URL.createObjectURL(blob);
              a.setAttribute("href", objectUrl);
              a.setAttribute("download", "个人会员统计名单.xlsx");
              a.click();
            });
          break;
      }
    },
    init(data) {
      this.loading = true;
      let params = data;
      if (params && Object.keys(params).includes("status")) {
        params.status = params.status ? "active" : "inactive";
      }
      params.current -= 1;
      this.queryParams = params
      this.$https.get(this.$api.Members.reportList, params).then((res) => {
        this.pagination = {
          pageSize: res.pageSize,
          current: res.currentPage + 1,
          total: res.count,
        };
        this.data = res.data
          ? res.data.map((el) => {
            return Object.assign(el, {
              status: el.status == "active" ? "启用" : "禁用",
              expert: el.expert ? "是" : "否",
              pay: el.pay ? "是" : "否",
              perMember: el.perMember ? "是" : "否",
              promisePay: el.promisePay ? "是" : "否",
              auditingStatus:
                el.auditingStatus == "PADDING"
                  ? "待审核"
                  : el.auditingStatus == "FALL"
                    ? "不通过"
                    : "通过",
            });
          })
          : [];
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/deep/.el-dialog__body {
  padding: 0;
}
</style>